import { JSXElementConstructor, ReactElement } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface IProps {
  tooltip: string;
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  placement?: "top" | "bottom";
}

const TooltipPopup = (props: IProps) => {
  const { placement = "bottom" } = props;

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip color="#000q2">{props?.tooltip}</Tooltip>}
    >
      <div>{props?.children}</div>
    </OverlayTrigger>
  );
};

export default TooltipPopup;
